import reducer from './reducer'

import * as calendarsOperations from './operations'
import * as calendarsSelectors from './selectors'

export { calendarsOperations, calendarsSelectors }

export default reducer
